import styled from 'styled-components'

export const FiltersWrapper = styled.div`
  overflow: hidden;

  margin: 29px 0 0 0;
  display: flex;
  justify-content: space-between;

  .search-input {
    min-width: 265px;
  }

  .link-add {
    display: block;
    float: left;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Filter/FiltersWrapper/index.js